<template>
  <div class="flex items-center mb-4 md:mb-8">
    <MoleculePicture
      v-if="image"
      :image="image"
      :alt="title"
      class="relative block mr-2 w-10 h-10 border-r-2 border-solid border-app-green rounded overflow-hidden md:w-12 md:h-12"
    />

    <p class="text-xs leading-tight md:text-base">
      <!-- TODO: add translation here for “Door:” -->
      <strong v-if="title" class="block">Door: {{ title }}</strong>
      <span v-if="role" class="block">{{ role }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  role?: string
  image?: object
}

defineProps<Props>()
</script>
